if (!customElements.get('card-slider')) {
  
  customElements.define(
    
    'card-slider',
    
    class CardSlider extends HTMLElement {
      
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        PCOtheme.Motion.inView(this, this.initSwiper.bind(this), { margin: '200px 0px 200px 0px' });
      }
      
      get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.swiperWrapper.children));
      }
      
      initSwiper() {
        
        const slider = this.querySelector('.swiper');
        
        if (!slider) return;
        
        const swiper = new PCOtheme.Swiper.Swiper(slider, {
          modules: [
            PCOtheme.Swiper.Navigation,
            PCOtheme.Swiper.Scrollbar,
            PCOtheme.Swiper.Mousewheel
          ],
          navigation: PCOtheme.Swiper.NavigationDefault,
          scrollbar: PCOtheme.Swiper.ScrollbarDefault,
          mousewheel: PCOtheme.Swiper.MousewheelDefault,
          slidesPerView: 'auto',
          slidesPerGroupAuto: true,
          speed: 500,
          spaceBetween: 13,
          slidesOffsetBefore: 18,
          slidesOffsetAfter: 18,
          breakpoints: {
            750: {
              spaceBetween: 18,
              slidesOffsetBefore: 40,
              slidesOffsetAfter: 40
            },
            1025: {
              spaceBetween: 24,
              slidesOffsetBefore: 60,
              slidesOffsetAfter: 60
            }
          }
        });
        
        // handle theme editor
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            swiper.slideTo(this.getSlideItems.indexOf(event.target));
          });
        }
      }
    }
  );
}